var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8132 38.7725C38.4755 38.7725 41.4443 35.7404 41.4443 32C41.4443 28.2597 38.4755 25.2275 34.8132 25.2275C31.151 25.2275 28.1821 28.2597 28.1821 32C28.1821 35.7404 31.151 38.7725 34.8132 38.7725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8131 47.2382C53.1244 47.2382 67.9686 40.4158 67.9686 32.0001C67.9686 23.5843 53.1244 16.762 34.8131 16.762C16.5019 16.762 1.65771 23.5843 1.65771 32.0001C1.65771 40.4158 16.5019 47.2382 34.8131 47.2382Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8921 39.619C31.0477 55.8152 44.2548 65.5336 51.3909 61.3257C58.527 57.1178 56.8898 40.5771 47.7342 24.3809C38.5786 8.18475 25.3715 -1.53366 18.2354 2.67423C11.0994 6.88211 12.7365 23.4229 21.8921 39.619Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.892 24.3808C12.7364 40.577 11.0992 57.1177 18.2353 61.3256C25.3714 65.5335 38.5784 55.8151 47.7341 39.6189C56.8897 23.4228 58.5268 6.88205 51.3907 2.67416C44.2546 -1.53372 31.0476 8.18469 21.892 24.3808Z",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.6264,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.642007dfaecf3d111b72521797fb13b9.svg";
export { ForwardRef as ReactComponent };